const ALLOWED_EXTS = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp']);

function hex8(): string {
  const bytes = new Uint8Array(4);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function makePlaceholderName(input: string): string {
  const lastDot = input.lastIndexOf('.');
  const rawName = lastDot > 0 ? input.slice(0, lastDot) : input;
  const rawExt = lastDot > 0 ? input.slice(lastDot + 1).toLowerCase() : '';
  const ext = ALLOWED_EXTS.has(rawExt) ? rawExt : 'png';
  const cleaned = rawName
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase();
  const stem = cleaned || 'image';
  return `${stem}-${hex8()}.${ext}`;
}

// Image references: markdown `![alt](filename.png)` and JSX `src="filename.png"`.
// Absolute URLs (http/https) and data: URIs are excluded — only bare filenames
// (no slash, no protocol) are candidates.
const MD_IMAGE_RE = /!\[[^\]]*?\]\(([^)\s]+)\)/g;
const JSX_SRC_RE = /\bsrc\s*=\s*(?:"([^"]+)"|'([^']+)')/g;

export function extractReferencedFilenames(mdx: string): string[] {
  const out = new Set<string>();
  const consider = (raw: string) => {
    if (!raw) return;
    if (raw.includes('://') || raw.startsWith('data:') || raw.startsWith('/')) return;
    out.add(raw);
  };
  for (const m of mdx.matchAll(MD_IMAGE_RE)) consider(m[1]);
  for (const m of mdx.matchAll(JSX_SRC_RE)) consider(m[1] ?? m[2] ?? '');
  return [...out];
}
